import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const ClawMachines = () => {
  return (
    <>
    <Helmet>
      <title>Claw Machines in Ottawa | Den Den Claw Arcade</title>
      <meta
        name="description"
        content="Play Japanese-style UFO catcher claw machines at Den Den Claw in Ottawa. Skill-based games with real prizes — win, keep, or trade in for store credit."
      />
      <link rel="canonical" href="https://www.dendenclaw.com/explore/claw-machines" />
    </Helmet>
    <Box sx={{ py: 6 }}>
      <Container maxWidth="xl">
        {/* ---------- HEADER ---------- */}
        <Typography
          variant="h4"
          sx={{ fontWeight: 700, textAlign: "center", mb: 2 }}
        >
          Claw Machines 🎯
        </Typography>

        <Typography
          variant="subtitle1"
          sx={{
            textAlign: "center",
            maxWidth: 700,
            mx: "auto",
            mb: 6,
            color: "text.secondary",
          }}
        >
            Den Den Claw is a skill-based claw machine arcade in Ottawa, featuring a mix
  of beginner-friendly machines and authentic Japanese UFO catchers.
        </Typography>
        <Typography sx={{ color: "text.secondary" }}>
          Win prizes to keep, or trade them in for points toward bigger rewards.
        </Typography>


        {/* ---------- HERO IMAGE ---------- */}
        <Box
          component="img"
          src="/clawmachines/hero.jpg" // TODO: add hero photo
          alt="Claw machines at Den Den Claw"
          sx={{
            width: "100%",
            maxHeight: 420,
            objectFit: "cover",
            borderRadius: 3,
            mb: 8,
          }}
        />

        {/* ---------- HOW IT WORKS ---------- */}
        <Grid container spacing={4} sx={{ mb: 8 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
              How It Works 🧠
            </Typography>

            <Typography sx={{ mb: 1 }}>
              • Purchase tokens and choose a machine
            </Typography>
            <Typography sx={{ mb: 1 }}>
              • Win prizes using timing, positioning, and technique
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="/clawmachines/coins.jpg" // TODO: add photo
              alt="Playing a claw machine"
              sx={{
                width: "100%",
                height: 260,
                objectFit: "cover",
                borderRadius: 3,
              }}
            />
          </Grid>
        </Grid>

        {/* ---------- PRIZES & TRADING ---------- */}
        <Grid container spacing={4} sx={{ mb: 8 }}>
          <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
            <Box
              component="img"
              src="/clawmachines/prizes.jpg" // TODO: prize wall photo
              alt="Prizes and trade-in items"
              sx={{
                width: "100%",
                height: 260,
                objectFit: "cover",
                borderRadius: 3,
              }}
            />
          </Grid>

          <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
              Win, Keep, or Trade 🎁
            </Typography>

            <Typography sx={{ mb: 1 }}>
              Every prize you win is yours to keep — no strings attached.
            </Typography>
            <Typography sx={{ mb: 1 }}>
              Want something bigger? Trade in multiple prizes for points and
              redeem them for higher-value items.
            </Typography>
            <Typography>
              Our prize selection includes video game merch, anime figures,
              Japanese mascots, and all kinds of cute collectibles.
            </Typography>
          </Grid>
        </Grid>

        {/* ---------- UFO MACHINES ---------- */}
        <Grid container spacing={4} sx={{ mb: 8 }}>
          <Grid item xs={12} md={6}>
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
              Japanese UFO Machines 🇯🇵
            </Typography>

            <Typography sx={{ mb: 1 }}>
              We feature authentic UFO catcher machines imported from Japan.
            </Typography>
            <Typography sx={{ mb: 1 }}>
              These machines are highly skill-based — perfect for players who
              enjoy mastering techniques rather than relying on luck.
            </Typography>
            <Typography>
              Not sure where to start? Our staff is always happy to help you
              learn the basics.
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="/clawmachines/ufo.jpg" // TODO: UFO machine photo
              alt="Japanese UFO catcher machines"
              sx={{
                width: "100%",
                height: 260,
                objectFit: "cover",
                borderRadius: 3,
              }}
            />
          </Grid>
        </Grid>

        {/* ---------- WHY DEN DEN ---------- */}
    <Card
  sx={{
    borderRadius: 3,
    boxShadow: 6,
    p: 4,
    textAlign: "center",
    background: "linear-gradient(180deg, #e8f2ff 0%, #f5faff 100%)",
  }}
>
  <CardContent>
    <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
      Ready to Play? 🎮
    </Typography>

    <Typography sx={{ mb: 3, color: "text.secondary" }}>
      Whether it’s your first time or your fiftieth, the best way to experience
      Den Den Claw is in person. Come by, try a few machines, and see what you
      can win!
    </Typography>

    <Button
      variant="contained"
      size="large"
      component={Link}
      to="/contact"
      sx={{
        borderRadius: 999,
        px: 4,
        textTransform: "none",
        fontWeight: 600,
      }}
    >
      Visit Us
    </Button>
  </CardContent>
</Card>

      </Container>
    </Box>
    </>
  );
};

export default ClawMachines;
